import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Grid, Stack, Box, Typography, Divider, } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import { CardMembership, } from '@mui/icons-material';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import MenuBookIcon from '@mui/icons-material/MenuBook';
// import EventNoteIcon from '@mui/icons-material/EventNote';
import PeopleIcon from '@mui/icons-material/People';
import QuizIcon from '@mui/icons-material/Quiz';
import { formatDuration, useTokens } from '@mcn-platform/models';
import CallToAction from '../../card/enrollPrice/CallToAction';
import capitalizeFirstLetter from '../../../common/capitalizeFirstLetter';
const ItemGlance = ({ name, settings, isProgram, certificationName, lessonCount, courseCount, 
// startDate,
// expiryDate,
enrollmentCount, gated, length, level, price, sellPrice, quizCount, hasMaterials, action, buttonLabel, showPrice, hasCertification, isCourse, isScorm, }) => {
    const tokens = useTokens();
    const iconSx = {
        fontSize: isProgram ? 25 : 45,
        color: (t) => (t.portal?.landingPage?.sectionText?.font?.color),
    };
    const itemGlance = [
        {
            id: 'pd-cert', text: certificationName, show: certificationName, Icon: _jsx(AcUnitIcon, { sx: iconSx }),
        },
        {
            id: 'pd-lesson-count',
            text: `${lessonCount} ${tokens.getToken('lessonName/plural')}`,
            show: (lessonCount && lessonCount > 0) && !isScorm,
            Icon: _jsx(MenuBookIcon, { sx: iconSx }),
        },
        {
            id: 'pd-course-count', text: `${courseCount} ${tokens.getToken('courseName/plural')}`, show: (courseCount && courseCount > 0), Icon: _jsx(MenuBookIcon, { sx: iconSx }),
        },
        // {
        //   id: 'pd-days-to-expire', text: getDateDifferenceInDays(startDate, expiryDate),
        // show: false, Icon: (props: any) => <EventNoteIcon {...props} />,
        // },
        {
            id: 'pd-gage', text: gated ? 'Gated' : 'Ungated', show: false, Icon: _jsx(FormatListNumberedIcon, { sx: iconSx }),
        },
        {
            id: 'pd-enrollment', text: `${enrollmentCount} Enrolled`, show: false, Icon: _jsx(PeopleIcon, { sx: iconSx }),
        },
        {
            id: 'pd-level', text: `Level: ${capitalizeFirstLetter(level)}`, show: true, Icon: _jsx(AcUnitIcon, { sx: iconSx }),
        },
        {
            id: 'pd-length', text: `Estimated Time To Complete ${formatDuration(length)}`, show: settings.showContentLengthDetail, Icon: _jsx(AccessTimeIcon, { sx: iconSx }),
        },
        {
            id: 'pd-quiz-count', text: 'This Course Includes a Quiz', show: Boolean(quizCount), Icon: _jsx(QuizIcon, { sx: iconSx }),
        },
        {
            id: 'pd-downloads', text: 'This Course Has Materials', show: hasMaterials, Icon: _jsx(CloudDownloadOutlinedIcon, { sx: iconSx }),
        },
        {
            id: 'pd-cert-', text: `Certification ${isCourse ? 'Course' : 'Program'}`, show: hasCertification, Icon: _jsx(CardMembership, { sx: iconSx }),
        },
    ];
    return (_jsxs(Stack, { children: [_jsx(Typography, { variant: "subtitle1", className: "landingpage-section-subheader", children: `${name || 'Course'} Details` }), settings.showDividers && (_jsx(Divider, { sx: {
                    width: '100%',
                    borderBottomWidth: 3,
                    mt: 1.5,
                    mb: 1,
                    borderColor: (t) => (t.portal.site.lineColor),
                } })), _jsxs(Grid, { container: true, sx: {
                    gap: 2,
                    // px: isProgram ? 0 : 0.9,
                }, children: [itemGlance.map(({ id, text, show, Icon, }) => (show ? (_jsxs(React.Fragment, { children: [_jsxs(Grid, { item: true, xs: isProgram ? 12 : 6, md: isProgram ? 12 : 5, py: 0.25, display: "flex", flexDirection: "row", alignItems: "center", flexGrow: 1, children: [_jsx(Box, { sx: { minWidth: isProgram ? 35 : 60 }, children: Icon }), _jsx(Typography, { component: "div", sx: {
                                            marginY: 'auto',
                                            color: (t) => (t.portal?.landingPage?.sectionText?.font?.color),
                                            // textTransform: 'capitalize',
                                        }, children: text })] }), settings.showDividers && (_jsx(Divider, { sx: {
                                    my: 1,
                                    width: '100%',
                                    borderColor: (t) => (t.portal.site.lineColor),
                                } }))] }, id)) : '')), isProgram && (_jsx(Stack, { direction: "row", justifyContent: "center", sx: { width: '100%', py: 1 }, children: _jsx(CallToAction, { showPrice: showPrice, showButton: settings.showButton, price: price, sellPrice: sellPrice, action: action, buttonLabel: buttonLabel }) }))] })] }));
};
ItemGlance.defaultProps = {
    isProgram: false,
    sellPrice: undefined,
    lessonCount: null,
    courseCount: null,
    settings: {
        showDividers: false,
        showGatedDetail: true,
        showContentLengthDetail: true,
        showPrice: false,
        showEnrollButton: false,
    },
};
export default ItemGlance;
//# sourceMappingURL=ItemGlance.js.map